// Shared body for the identical-shaped account form documents (profile edit /
// change password / address create-update); the per-page variance (form_id,
// content title, submit/cancel labels, chrome defaults) is all resolved
// server-side. Typed on the common field subset it reads, not a full
// templates.X -- leaf/structural components take the narrowest projection;
// only a top-level XBody may take a whole template's props.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "../../../forms/classNames";
import { AccountContentTitle } from "../AccountContentTitle";
import { FormFields } from "../FormFields";
import { SideNav } from "../SideNav";

// ProfileUpdateDocumentTemplate, ChangePasswordDocumentTemplate, and
// AddressFormDocumentTemplate generate identical field shapes; index one of
// them for the complex field types.
type ITemplate = templates.ProfileUpdateDocumentTemplate;

type IProps = Immutable<{
    has_nav: boolean;
    side_nav: ITemplate["side_nav"];
    content_title: string;
    phone_display: string;
    phone_href: string;
    form_id: string;
    action_url: string;
    fields: ITemplate["fields"];
    field_labels: ITemplate["field_labels"];
    field_errors: ITemplate["field_errors"];
    non_field_errors: ITemplate["non_field_errors"];
    submit_text: string;
    cancel_text: string;
}>;

export const AccountFormBody = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
        {props.has_nav && (
            <div className="l-side-nav">
                <SideNav items={props.side_nav} />
            </div>
        )}

        <div className="l-side-nav-content">
            <AccountContentTitle
                contentTitle={props.content_title}
                phoneDisplay={props.phone_display}
                phoneHref={props.phone_href}
            />

            <div className="content__copy--full-width">
                <div className="my-account-form">
                    <form
                        id={props.form_id}
                        className={FORM_CLASS_NAME}
                        method="post"
                        action={props.action_url}
                    >
                        <CSRFToken />
                        <FormFields
                            fields={props.fields}
                            field_labels={props.field_labels}
                            field_errors={props.field_errors}
                            non_field_errors={props.non_field_errors}
                        />
                        <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                            <input
                                type="submit"
                                className="button button--full-width"
                                value={props.submit_text}
                            />
                        </div>
                        <div className={FORM_FIELD_CLASS_NAME}>
                            <button
                                type="button"
                                className="button button--secondary button--full-width"
                                onClick={() => getWindow()?.history.go(-1)}
                            >
                                {props.cancel_text}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
);
